module.exports = __webpack_public_path__ + "f17722d81131bdadbac82d7f1d7e6849.pdf";